import { useStore } from 'vuex';

function toCamelCase(string) {
  return string
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''));
}

/**
 * Provides easy access to the profile's role permissions
 *
 * Usage:
 * ```
 * const { paymentsEdit, formsAdmin } = useRolePermissions();
 * if (paymentsEdit) { ... }
 * ```
 *
 * @returns {Object} An object containing camel case properties for all permissions
 */
export default function useRolePermissions(store = useStore()) {
  const rolePermissions = store?.state?.profile?.role_permissions || {};
  const rolePermissionsObject = {};

  Object.keys(rolePermissions).forEach((key) => {
    const camelCaseKey = toCamelCase(key);
    rolePermissionsObject[camelCaseKey] = !!rolePermissions[key];
  });

  return {
    rolePermissions,
    ...rolePermissionsObject,
  };
}
